import { render, staticRenderFns } from "./ComplaintsTable.vue?vue&type=template&id=2e6ee49b&scoped=true"
import script from "./ComplaintsTable.vue?vue&type=script&lang=js"
export * from "./ComplaintsTable.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsTable.vue?vue&type=style&index=0&id=2e6ee49b&prod&scoped=true&lang=css"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=2e6ee49b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ee49b",
  null
  
)

export default component.exports